import { marked } from 'marked';
import TurndownService from 'turndown';

const turndown = new TurndownService({
  headingStyle: 'atx',
  bulletListMarker: '-',
  codeBlockStyle: 'fenced',
  emDelimiter: '*',
  strongDelimiter: '**',
});

turndown.addRule('lineBreak', {
  filter: 'br',
  replacement: () => '\n',
});

export const markdownToHtml = (markdown) => {
  if (!markdown) return '';
  return marked.parse(markdown, { breaks: true, gfm: true });
};

export const htmlToMarkdown = (html) => {
  if (!html) return '';
  return turndown.turndown(html).replace(/\u00a0/g, ' ').trim();
};
